import client from '../httpClient';

const actDeleteHistoryApi = (pathParameter) => {
  return client.delete(`/actions/histories/${pathParameter}`, { isShowLoading: false });
};

export default actDeleteHistoryApi;
